import type { ReactNode } from 'react';

import { SectionHeader } from '../../shared/SectionHeader';

interface LegalComplianceSectionBaseProps {
  legalUrlFields: ReactNode;
}

export function LegalComplianceSectionBase({
  legalUrlFields,
}: LegalComplianceSectionBaseProps) {
  return (
    <section className="self-stretch flex flex-col gap-6">
      <SectionHeader title="Compliance" />

      {legalUrlFields}
    </section>
  );
}
